import { createAction } from 'redux-act';

export const authenticationRequired = createAction('AUTHENTICATION_REQUIRED');
